<template>
  <section>
    <div
      ref="episodeList"
      class="episodes">
      <div class="episodes__header">
        <router-link
          v-button-event="{buttonName: 'MLP Episodes Signup'}"
          v-if="!userPremium"
          to="/signup"
        >Subscribe to Luminary to stream all episodes of The Midnight Miracle</router-link>
      </div>
      <div class="episodes__items">
        <episode-item
          v-for="episode in episodes"
          :key="episode.id"
          :episode="episode"
        />
      </div>
    </div>
  </section>
</template>

<script>
import EpisodeItem from './EpisodeItem';

export default {
  name: 'MLPEpisodes',
  components: {
    EpisodeItem,
  },
  props: {
    episodes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    userPremium() {
      return this.userSubscriptionState === 'premium' || this.userSubscriptionState === 'premiumChurned';
    },
  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables.scss";
@import "./mlp.scss";

.episodes {
  text-align: center;
  padding: 0 0 60px;
  @media (max-width: $sm) {
    padding: 0;
  }
  &__header {
    margin-bottom: 45px;
    @media (max-width: $xs) {
      margin-bottom: 25px;
    }
    a {
      @include mlp-title;
      color: #FEFEFC;
      &:hover {
        color: #00AECB;
        text-decoration: underline;
      }
    }
  }
  &__items {
    margin-bottom: 45px;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }
  &__footer {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #00AECB;
    text-decoration: underline;
    @media (max-width: $xs) {
      padding: 0 10px;
    }
  }
}
</style>
